module.exports = __webpack_public_path__ + "static/boys_girls_clubs-adec58790de58774b5a960213459bd09.png";